import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=6c58d484&"
import script from "./StaffCard.vue?vue&type=script&lang=js&"
export * from "./StaffCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c58d484')) {
      api.createRecord('6c58d484', component.options)
    } else {
      api.reload('6c58d484', component.options)
    }
    module.hot.accept("./StaffCard.vue?vue&type=template&id=6c58d484&", function () {
      api.rerender('6c58d484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/StaffCard.vue"
export default component.exports